import Vue from 'vue'
import getMP from 'app/web/utils/getMP.js'

Vue.prototype.$getMP = window.$getMP = getMP()

if (window.$getMP) {
  init()
}
function init() {
  const userAgent = navigator.userAgent
  if (userAgent.indexOf('AlipayClient') > -1) {
    // 支付宝小程序的 JS-SDK 防止 404 需要动态加载，如果不需要兼容支付宝小程序，则无需引用此 JS 文件。
    document.writeln(
      '<script src="https://appx/web-view.min.js"' + '>' + '<' + '/' + 'script>'
    )
  } else if (/QQ/i.test(userAgent) && /miniProgram/i.test(userAgent)) {
    // QQ 小程序
    document.write(
      '<script type="text/javascript" src="https://qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js"><' +
        '/script>'
    )
  } else if (/miniProgram/i.test(userAgent)) {
    // 微信小程序 JS-SDK 如果不需要兼容微信小程序，则无需引用此 JS 文件。
    document.write(
      '<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"><' +
        '/script>'
    )
  } else if (/toutiaomicroapp/i.test(userAgent)) {
    // 头条小程序 JS-SDK 如果不需要兼容头条小程序，则无需引用此 JS 文件。
    document.write(
      '<script type="text/javascript" src="https://s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js"><' +
        '/script>'
    )
  } else if (/swan/i.test(userAgent)) {
    // 百度小程序 JS-SDK 如果不需要兼容百度小程序，则无需引用此 JS 文件。
    document.write(
      '<script type="text/javascript" src="https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.18.js"><' +
        '/script>'
    )
  }
  let loadUniScript = new Promise(resolve => {
    setTimeout(() => {
      const { loadScript } = require('lib/tools/loadScript')
      loadScript(
        `https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js`
      ).then(resolve)
    }, 2000)
  })
  if (
    !/toutiaomicroapp/i.test(userAgent) &&
    document.querySelector('.post-message-section')
  ) {
    document.querySelector('.post-message-section').style.visibility = 'visible'
  }

  function togo(nav, data = {}) {
    let url = ''
    if (Object.prototype.toString.call(nav) === '[object Object]') {
      if (nav.path) {
        url = nav.path
      } else if (nav.name) {
        url = `/pages/${nav.name}/${nav.name}`
      }

      data = {
        ...nav.data,
        ...nav.query,
        ...nav.params
      }
    } else {
      url = nav
    }
    url += (url.indexOf('?') < 0 ? '?' : '&') + param(data)
    return {
      url
    }
  }

  function param(data) {
    let url = ''
    for (var k in data) {
      let value = data[k] !== undefined ? data[k] : ''
      // url += '&' + k + '=' + encodeURIComponent(value)
      url += '&' + k + '=' + value
    }
    return url ? url.substring(1) : ''
  }

  const push = function (nav, data = {}) {
    console.log('push', togo(nav, data))
    uni.navigateTo(togo(nav, data))
  }
  const reLaunch = function (nav, data = {}) {
    console.log('reLaunch', togo(nav, data))
    uni.reLaunch(togo(nav, data))
  }
  const redirect = function (nav, data = {}) {
    console.log('redirect', togo(nav, data))
    uni.redirectTo(togo(nav, data))
  }

  const goIndex = function () {
    uni.switchTab({
      url: '/pages/explore/explore'
    })
  }

  const back = function (num = 1) {
    uni.navigateBack({
      delta: num
    })
  }

  const postMessage = function (data) {
    loadUniScript.then(() => {
      return uni.postMessage({
        data
      })
    })
  }

  Vue.prototype.$uniAppNavto = window.$uniAppNavto = {
    push,
    reLaunch,
    redirect,
    goIndex,
    back
  }

  Vue.prototype.$uniApp = {
    postMessage,
    push,
    reLaunch,
    redirect,
    goIndex,
    back
  }
}
